import { Pipe, PipeTransform } from '@angular/core';
import { TSource } from '@core/types/tsource';
import { environment } from '@env/environment';

import { EnApi } from '../../api/enums/api.enums';

@Pipe({
  name: 'src',
  standalone: true,
})
export class SrcPipe implements PipeTransform {
  transform(value: string, type: TSource = 'store'): string {
    switch (type) {
      case 'store': {
        return `${EnApi.STORE_HOST}/${value}`;
      }
      // When all media files will be moved to storage remove this case and from tsource.ts file in case of https://nodapay.atlassian.net/browse/WEB-1676 task
      case 'origin': {
        return `${EnApi.STORE_HOST}/noda-origin/${value}`;
      }
      case 'origin-storage': {
        return `${EnApi.STORE_HOST}/storage/projects/origin/${value}`;
      }
      case 'assets': {
        return `${environment.ASSETS_IMAGES}/${value}`;
      }
      case 'country-flag': {
        return `${EnApi.STORE_HOST}/flags/${value?.toLocaleLowerCase()}.svg`;
      }
      case 'tui': {
        return `${environment.ASSETS_PATH}/taiga-ui/${value}`;
      }
      default: {
        return value;
      }
    }
  }
}
